export default __webpack_public_path__ + "static/Slide4-d1a0ef2aa0f5e232b6e6a0d3d58ba49b.png";